import React                from 'react';
import { useSelector }      from 'react-redux';
import moment               from 'moment';
import { PROFILE_FISCAL }   from '../../../data/profiles';



const RequestInfo = () => {

    // Tomo el store
    const audience = useSelector(state => state.audiences.audienceWork);
    const authUser = useSelector(state => state.auth.user);

    // Renderizo
    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-2 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-primary">DATOS AUDIENCIA</h6>
                </div>
                <div className="card-body">
                    {   audience && audience.solicitante 
                            ?
                                <div className="h6 mb-0 font-weight-bold text-gray-800">
                                    <div className="row">
                                        <div className="col-md-2 mb-1">
                                            <small>F. SOLICITUD:</small>
                                            <br/>
                                            { audience.fechaSolicitud ? moment(audience.fechaSolicitud).format('DD/MM/YYYY HH:mm') : '' }
                                        </div>
                                        <div className="col-md-10 mb-1">
                                            <small>SOLICITANTE:</small>
                                            <br/>
                                            { audience.solicitante.descripcion }
                                            {   authUser 
                                                    ?
                                                        authUser.perfil.id === PROFILE_FISCAL 
                                                            ?
                                                                <small>{ audience.usuario ? ` (${audience.usuario.apellido}, ${audience.usuario.nombre})` : '' }</small>
                                                            : 
                                                                null
                                                    : 
                                                        null
                                            }
                                        </div>
                                        <div className="col-12 mb-1">
                                            <small>EXPEDIENTE:</small>
                                            <br/>
                                            {   audience.expediente 
                                                    ?
                                                        `${ audience.expediente.numero } - ${ audience.expediente.caratula }`
                                                    : 
                                                        null
                                            }
                                        </div>
                                        <div className="col-12 mb-1">
                                            <small>TIPO/S DE AUDIENCIA:</small>
                                            <br/>
                                            {   audience.audienciaTipoList.map( (type,index)=>(
                                                    <React.Fragment key={`aiat${type.id}`}>
                                                        {`${index > 0 ? ', ' : ''}${type.descripcion}`}
                                                    </React.Fragment>
                                                    ))
                                            }
                                        </div>
                                        <div className="col-md-6 mb-1">
                                            <small>UNIDAD FISCAL:</small>
                                            <br/>
                                            { audience.fiscalia ? audience.fiscalia.descripcion : '' }
                                        </div>
                                        <div className="col-md-6 mb-1">
                                            <small>FISCAL:</small>
                                            <br/>
                                            { audience.fiscal ? `${audience.fiscal.apellido}, ${audience.fiscal.nombre}` : 'S/D' }
                                        </div>
                                        {   audience.ofiju 
                                                ?
                                                    <div className="col-12 mb-1">
                                                        <small>OFIJU:</small>
                                                        <br/>
                                                        { audience.ofiju.nombre }
                                                    </div>
                                                : 
                                                    null
                                        }
                                        {   audience.vencimientoIPP 
                                                ?
                                                    <div className="col-12 mb-1">
                                                        <small>Vencimiento de IPP:</small>
                                                        <br/>
                                                        <span className='text-danger'>{ moment(audience.vencimientoIPP).format('DD/MM/YYYY') }</span>
                                                    </div>
                                                : 
                                                    null
                                        }
                                        {   audience.observacionSolicitante 
                                                ?
                                                    <div className="col-12 mb-1">
                                                        <small>OBSERVACIONES DEL SOLICITANTE:</small>
                                                        <br/>
                                                        { audience.observacionSolicitante }
                                                    </div>
                                                : 
                                                    null
                                        }
                                    </div>
                                </div>
                            : 
                                null
                    }
                </div>
            </div>
        </div>
    );
};

export default RequestInfo;
